import { useId } from 'react';
import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BrowserStackColor = forwardRef<IconProps, 'svg'>((props, ref) => {
  const id = useId();
  return (
    <Icon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.0232 22C17.5332 22 22 17.5332 22 12.0232C22 6.5132 17.5332 2.04645 12.0232 2.04645C6.51321 2.04645 2.04645 6.5132 2.04645 12.0232C2.04645 17.5332 6.51321 22 12.0232 22Z"
        fill="#F4B960"
      />
      <path
        d="M11.0115 20.023C15.9884 20.023 20.023 15.9884 20.023 11.0115C20.023 6.0346 15.9884 2 11.0115 2C6.0346 2 2 6.0346 2 11.0115C2 15.9884 6.0346 20.023 11.0115 20.023Z"
        fill="#E66F32"
      />
      <path
        d="M12.2527 17.6782C16.5693 17.6782 20.0686 14.1789 20.0686 9.86232C20.0686 5.54573 16.5693 2.04645 12.2527 2.04645C7.93611 2.04645 4.43683 5.54573 4.43683 9.86232C4.43683 14.1789 7.93611 17.6782 12.2527 17.6782Z"
        fill="#E43C41"
      />
      <path
        d="M12.8501 17.6317C16.8111 17.6317 20.0221 14.4207 20.0221 10.4597C20.0221 6.49866 16.8111 3.28763 12.8501 3.28763C8.88904 3.28763 5.678 6.49866 5.678 10.4597C5.678 14.4207 8.88904 17.6317 12.8501 17.6317Z"
        fill="#BDD041"
      />
      <path
        d="M12.3447 17.6782C16.0266 17.6782 19.0113 14.6934 19.0113 11.0115C19.0113 7.32962 16.0266 4.34485 12.3447 4.34485C8.66277 4.34485 5.678 7.32962 5.678 11.0115C5.678 14.6934 8.66277 17.6782 12.3447 17.6782Z"
        fill="#6DB54C"
      />
      <path
        d="M11.2874 15.4708C14.3598 15.4708 16.8504 12.9802 16.8504 9.90784C16.8504 6.83549 14.3598 4.34485 11.2874 4.34485C8.21509 4.34485 5.72445 6.83549 5.72445 9.90784C5.72445 12.9802 8.21509 15.4708 11.2874 15.4708Z"
        fill="#AEDAE6"
      />
      <path
        d="M12.1607 13.6778C14.7508 13.6778 16.8504 11.5782 16.8504 8.98811C16.8504 6.39806 14.7508 4.2984 12.1607 4.2984C9.57067 4.2984 7.47101 6.39806 7.47101 8.98811C7.47101 11.5782 9.57067 13.6778 12.1607 13.6778Z"
        fill="#56B8DE"
      />
      <path
        d="M12.7581 13.7243C15.0182 13.7243 16.8504 11.8921 16.8504 9.63192C16.8504 7.37178 15.0182 5.53958 12.7581 5.53958C10.4979 5.53958 8.66574 7.37178 8.66574 9.63192C8.66574 11.8921 10.4979 13.7243 12.7581 13.7243Z"
        fill="#00B1D5"
      />
      <path
        d="M12.1607 13.6778C14.0904 13.6778 15.6548 12.1135 15.6548 10.1838C15.6548 8.25405 14.0904 6.68971 12.1607 6.68971C10.231 6.68971 8.66667 8.25405 8.66667 10.1838C8.66667 12.1135 10.231 13.6778 12.1607 13.6778Z"
        fill={`url(#gradient_${id})`}
      />
      <path
        d="M12.1607 13.6778C14.0904 13.6778 15.6548 12.1135 15.6548 10.1838C15.6548 8.25405 14.0904 6.68971 12.1607 6.68971C10.231 6.68971 8.66667 8.25405 8.66667 10.1838C8.66667 12.1135 10.231 13.6778 12.1607 13.6778Z"
        fill="#221F1F"
      />
      <path
        d="M14.189 9.20297C14.4386 8.64684 14.3593 8.06966 14.0119 7.91381C13.6646 7.75795 13.1807 8.08244 12.9312 8.63856C12.6816 9.19469 12.7609 9.77186 13.1083 9.92772C13.4556 10.0836 13.9395 9.75909 14.189 9.20297Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id={`gradient_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0159 12.1321) scale(10.0807)"
        >
          <stop stopColor="#797979" />
          <stop offset="1" stopColor="#4C4C4C" />
        </radialGradient>
      </defs>
    </Icon>
  );
});

export default BrowserStackColor;
